import type { ReactNode } from 'react';
import { DialogSurface, type SurfaceProps } from './Surface.js';
import { useIsCompactViewport } from './media.js';

/**
 * A modal dialog that becomes a bottom sheet on a phone.
 *
 * The swap is measured here, not passed in. A `variant` prop would be correct
 * on fifteen screens and forgotten on the sixteenth, and the sixteenth is the
 * one somebody opens one-handed in a gym. Rubric C10 is a property of the
 * primitive, not a convention call sites follow.
 *
 * `size` applies to the dialog presentation only. A sheet is the width of the
 * phone, which is the entire point of it.
 */

export type DialogProps = SurfaceProps;

export function Dialog(props: DialogProps): ReactNode {
  const compact = useIsCompactViewport();
  return <DialogSurface {...props} presentation={compact ? 'sheet' : 'dialog'} />;
}
